import { render, staticRenderFns } from "./KMultiSelectDropdown.vue?vue&type=template&id=184632c8&scoped=true"
import script from "./KMultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./KMultiSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./KMultiSelectDropdown.vue?vue&type=style&index=0&id=184632c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184632c8",
  null
  
)

export default component.exports